/**
 * useChildEventIds — which events are child events (directly under another event in the campaign
 * hierarchy), for the calendar's "hide child events" (hierarchySync `childEventIds`).
 *
 * No event field says it, so this reads every tree: one ListCampaignRoots, one GetCampaignTree per
 * root — the same walk Edit Event's event picker does. Read once per page load.
 *
 * `ids` is undefined while loading and when the read fails. The calendar then hides nothing: hiding
 * is a convenience, and not knowing must not make events disappear. The failure is not surfaced —
 * the calendar simply shows everything, as it did before child events existed.
 */

import { useEffect, useState } from 'react';
import { eventHubCalendarClient } from '../client/EventCalendarClient';
import { childEventIds } from '../components/CampaignHierarchy/hierarchySync';

export function useChildEventIds(): { ids: ReadonlySet<string> | undefined; loading: boolean } {
  const [ids, setIds] = useState<ReadonlySet<string> | undefined>(undefined);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    childEventIds(eventHubCalendarClient().campaignHierarchy()).then(
      (found) => {
        if (cancelled) return;
        setIds(found);
        setLoading(false);
      },
      () => {
        if (!cancelled) setLoading(false);
      },
    );
    return () => {
      cancelled = true;
    };
  }, []);

  return { ids, loading };
}
